import type { IManualKeywords, IKeyword } from "app/pages/digital-marketing/keywords-campaigns/shared/types";

export function parseKeywordsFromText(value: string, manualSource: IManualKeywords): IManualKeywords {
    const keywordsMap: Map<string, IKeyword> = new Map();

    value
        .split(/\r?\n/)
        .filter((line: string): boolean => line.trim().length > 0)
        .forEach((line: string): void => {
            const [keyword, ...tags]: string[] = line
                .split(",")
                .map((word: string): string => word.trim().toLowerCase())
                .filter((word: string): boolean => word.length > 0);

            const keywordValue: string = keyword || "";

            if (keywordValue) {
                const existingKeyword = keywordsMap.get(keywordValue);

                if (existingKeyword) {
                    const combinedTags: string[] = [...new Set([...existingKeyword.tags, ...tags])];
                    keywordsMap.set(keywordValue, {
                        ...existingKeyword,
                        tags: combinedTags,
                    });
                } else {
                    keywordsMap.set(keywordValue, {
                        value: keywordValue,
                        tags: [...new Set(tags)],
                        searchEnginesIds: [],
                        sourceId: "manual",
                    });
                }
            }
        });

    const keywords = Array.from(keywordsMap.values()).filter((item: IKeyword): boolean => Boolean(item.value));

    return {
        ...manualSource,
        keywords,
    };
}
